









































/* Created- 11 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaCardFill from "@/Ui-Components/Common/Container/ParticaCardFill.vue";
import ParticaBaseView from "../../Base/ParticaBaseView.vue";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import { eParticaAction, getActionName, ParticaEvent } from "../../../Models/ParticaEvent";
import { ButtonConfig, ButtonType } from "../../../Models/Buttons";
import ParticaTitleBase from "../../Base/ParticaTitleBase.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import { IScheduledTaskService } from "../../../BusinessServices/scheduledtask";
import { ScheduledLiveTaskDTO, ScheduledLiveTaskHistoryDTO } from "../../../Generated/ParticaAPI";
import ScheduledTask from "@/Ui-Components/Title/ScheduledTask.vue";
import ParticaTree from "@/Ui-Components/Common/Tree/ParticaTree.vue";
import ParticaRightDrawer from "@/Ui-Components/Common/Container/ParticaRightDrawer.vue";
import { ParticaItem, ParticaSubItem } from "../../../Models/ParticaItem";

@Component(
	{
		name: "ScheduledTasks",
		components: {
			ParticaError,
			ParticaColumnContainer,
			ButtonList,
			ParticaCard,
			ParticaView,
			ScheduledTask,
			ParticaTree,
			ParticaRightDrawer,
			ParticaCardFill
		}
	})
export default class ScheculedTasks extends ParticaTitleBase {
	@Prop() private id: number;
	private scheduledTaskService: IScheduledTaskService;
	private tasks: ScheduledLiveTaskDTO[] = [];
	private tasksdata: ParticaItem[] = [];
	private drawer: boolean = false;
	private task: ScheduledLiveTaskDTO = new ScheduledLiveTaskDTO();
	private historydrawer: boolean = false;

	private buttons: ButtonConfig[] = [
		{ label: "Add Task", action: eParticaAction.PUBLICATION_ADD_SCHEDULED_TASK, type: ButtonType.OK } as ButtonConfig,
	] as ButtonConfig[];
	private taskbuttons: ButtonConfig[] = [
		{ label: "Save", action: eParticaAction.PUBLICATION_SAVE_SCHEDULED_TASK, type: ButtonType.OK } as ButtonConfig,
		{ label: "History", action: eParticaAction.PUBLICATION_SCHEDULED_TASK_HISTORY, type: ButtonType.OK } as ButtonConfig,
		{ label: "Delete", action: eParticaAction.PUBLICATION_SCHEDULED_TASK_DELETE, type: ButtonType.Cancel } as ButtonConfig,
	] as ButtonConfig[];

	private history(task: ScheduledLiveTaskDTO): ScheduledLiveTaskHistoryDTO[] {
		if (task.scheduledLiveTaskHistories !== undefined) {
			return task.scheduledLiveTaskHistories.slice().reverse();
		} else {
			return [];
		}
	}

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.PUBLICATION_ADD_SCHEDULED_TASK: {
					this.task = new ScheduledLiveTaskDTO();
					this.task.publicationId = this.id;
					this.task.status = 0;
					this.drawer = true;
					break;
				}
				case eParticaAction.PUBLICATION_SCHEDULED_TASK_DELETE: {
					await this.scheduledTaskService.delete(this.task);
					this.drawer = false;
					await this.init();
					break;
				}
				case eParticaAction.PUBLICATION_SAVE_SCHEDULED_TASK: {
					await this.scheduledTaskService.save(this.task);
					await this.init();
					break;
				}
				case eParticaAction.PUBLICATION_SCHEDULED_TASK_HISTORY: {
					this.historydrawer = true;
					break;
				}
				case eParticaAction.LEFT_MOUSE_CLICK: {
					this.task = this.tasks.filter(t => (t.id as number).toString() === event.item.id)[0];
					this.drawer = true;
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}



	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Scheduled Tasks";
		this.scheduledTaskService = this.particaServices.getScheduledTasksService();
		await this.init();
		await this.getTitleNav(this.id);
	}

	private async init() {
		try {
			this.LoadingStart();
			this.tasksdata = [];
			this.tasks = await this.scheduledTaskService.get(this.id);
			const liveTask: ParticaItem = new ParticaItem();
			liveTask.id = "0";
			liveTask.name = "Make Issue Live";
			liveTask.children = [];
			liveTask.open = true;
			this.tasksdata.push(liveTask);
			this.tasks.forEach(task => {
				const stask: ParticaSubItem = { name: `Make Issue Live ${task.time} GMT`, id: (task.id as number).toString(), parentid: liveTask.id } as ParticaSubItem;
				liveTask.children.push(stask);
			});

		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
